import React, { useState } from 'react'
import { Col, Icon, IconButton, Panel, Row } from 'rsuite'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import pathname from '../../constants/pathname'
import { doneLoading, startLoading } from '../../utils/loading'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import ProjectBudgetReportTable from './ProjectBudgetReportTable'
import { downloadFile } from '../../utils/fileUtil'
import {
  downloadDashboardProjectBudgetReport,
  downloadDashboardProjectContractReport,
} from '../../redux/actions/dashboard'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'

export default function ProjectBudgetReportWidget(props) {
  const history = useHistory()

  const [isLoading, setIsLoading] = useState(false)
  const [dataTable, setDataTable] = useState(props.schema)

  const handleExportFile = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let req = sessionStorage.getItem('up-down-strem-req')
      let key = sessionStorage.getItem('up-down-strem-key')
      let masterKey = sessionStorage.getItem('up-down-strem-master-key')
      let status = sessionStorage.getItem('up-down-strem-status')

      let request = {}
      if (req && req !== 'undefined' && typeof req !== 'undefined') {
        request = JSON.parse(req)
      }

      const file = await downloadDashboardProjectContractReport(request, masterKey, key)
      // console.log('file => ', file)

      if (file) {
        downloadFile(file, file.name || `รายการโครงการ ${status || ''}`)
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSelect = (request) => {
    console.log('ressss -=> ', request)
    sessionStorage.setItem('projectId', request.projectVersionId)
    sessionStorage.setItem('param', '')

    history.push(`${pathname.proposal.overview.overviewCoworker}`)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}

      <Panel shaded collapsible defaultExpanded header={''} bordered>
        <Row style={{ marginTop: 20 }}>
          <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <IconButton
              appearance="ghost"
              icon={<Icon icon="print" className="bt-gost-icon-radius" />}
              onClick={() => {
                handleExportFile()
              }}
            >
              Export
            </IconButton>
          </Col>
        </Row>

        <ProjectBudgetReportTable
          schema={dataTable}
          loading={isLoading}
          // onReload={onReload}
          // page={page}
          // displayLength={displayLength}
          // isViewMode={isViewMode}
          onSelect={onSelect}
        />
      </Panel>
    </>
  )
}
